module.exports = __webpack_public_path__ + "static/EnmTX_Gaston_L_A_cl-d6bb9959af66c33525ec60a80534a4c4.gif";